<template>
	<div>
		<div style="height: 80px;"></div>
		<div style="background: #F8F8F8; height: 30px;line-height: 30px;">
			<div class="container">
				首页 > 新闻中心 > 企业动态 > 文章详情
			</div>
		</div>
		<!-- 新闻内容 -->
		<div class="container">
			<div style="height:  15px;"></div>
			<div class="pcpadding" style="background-color: white;width: 100%;">
				<!-- 标题 -->
				<div style="color: #333333;font-weight: bold;font-size: 39px;line-height: 59px;">
					{{title}}
				</div>
				<!-- 时间 -->
				<div style="height: 25px;"></div>
				<div class="context_tiem alibabapuhuiti_bold">
					2022-04-01
				</div>

				<!-- 新闻内容 -->
				<div style="height: 35px;"></div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					{{内容1}}
				</div>
				<div style="height:  35px;"></div>
				<img style="width: 100%;" src="../../static/news/2/1.png"></img>
				<!-- 新闻内容end -->


			</div>
			<div style="height:  45px;"></div>
		</div>
		<!-- 新闻内容 end -->


	</div>
</template>
<script>
	export default {
		name: 'Newdetails',
		components: {


		},
		data() {
			return {

			}
		},

	}
</script>

<style>
	.context_tiem {
		color: #5D8299;
		size: 17px;
	}
	@media (min-width: 1000px) {
		.pcpadding {
			padding: 55px 200px 55px 200px;
		}
	}
</style>
